<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="secondary" v-b-tooltip.hover :title="showToolTip ? tooltip : ''"><i class="fa fa-arrow-left"></i></b-button>
</template>

<script>

export default ({
  name: "button-back",

  props: {
    tooltip: {
      type: String,
      default: 'Назад'
    }
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
